// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__pInEu","container":"styles_container__4tlm_","text":"styles_text__jSdVD","dropdownWrapper":"styles_dropdownWrapper__pp62u"};